export class PromotionProduct {
  constructor(promotionData = null) {
    if (promotionData) {
      this.currentPage = promotionData?.currentPage || 1;
      this.perPage = promotionData?.perPage || 0;
      this.total = promotionData?.total || 0;
      this.totalPages = promotionData?.totalPages || 0;
      this.products = promotionData?.data?.length ? promotionData.data.map(product => new Product(product)) : [];
    }
  }
}
export class Product {
  constructor(data = null) {
    if (data) {
      this.availables = data?.availables?.length ? data.availables.map(available => new Available(available)) : [];
      this.amwayValue = data.amwayValue || {
        businessVolume: 0, pointValue: 0, returnableBV: 0, returnablePV: 0
      };
      this.backgroundColor = data?.backgroundColor || '';
      this.backgroundImage = data?.backgroundImage || '';
      this.cardImageUrl = data?.cardImageUrl || '';
      this.condition = data?.condition || '';
      this.description = data?.description || '';
      this.displayType = data?.displayType || '';
      this.endDate = data?.endDate || '';
      this.freegifts = data?.freegifts || [];
      this.galleryImages = data?.galleryImages || [];
      this.icon = data?.icon || '';
      this.id = data?.id || '';
      this.identifier = data.identifier || ""
      this.instalmentDetail = data?.instalmentDetail || '';
      this.isFlashSale = data?.isFlashSale || false;
      this.isNotAbleToSale = data?.isNotAbleToSale || false;
      this.kitEntries = data?.kitEntries || [];
      this.moreDescription = data?.moreDescription || '';
      this.name = data?.name || '';
      this.prices = data.prices || [{ type: "RETAIL", price: "", currency: { digit: "0", symbol: "฿", ISOCode: "THB" } }];
      this.paymentOptions = data?.paymentOptions || [];
      this.relatedPremiumItems = data?.relatedPremiumItems || [];
      this.relatedProducts = data?.relatedProducts || [];
      this.sequence = data?.sequence || null;
      this.shortDescription = data?.shortDescription || '';
      this.sku = data.sku || "";
      this.startDate = data?.startDate || '';
      this.stock = data?.stock || { isStockAvailable: false, stockLevelStatus: '', stockLevelStatusName: '' };
      this.summary = data?.summary || '';
      this.tags = data?.tags || [];
      this.textColor = data?.textColor || '';
      this.isKitProduct = data?.isKitProduct || false;
    }
  }
}

export class Available {
  constructor(data = null) {
    if (data) {
      this.endDate = data?.endDateTime || '';
      this.startDate = data?.startDateTime || '';
      this.type = data?.type || '';
      this.typeSpecialLabel = data?.typeSpecialLabel || '';
    }
  }
}